<template>
	<div class="fixed-center text-center">
		
	</div>
</template>

<script>
export default {
	name: '404',

	i18nOptions: { namespaces: ["common"] },

	created() {
		this.$router.replace({ name: 'home' })
	}
}
</script>